import { FormattedDate, FormattedNumber } from 'react-intl'

import type { StylableElementProps } from '@subaio/components'
import { isNonNullable } from '@subaio/utils'

import { Cell } from 'components/Lists'

import { Amount } from '../Amount'
import { EmptyChevron } from '../EmptyChevron'
import { Faded } from './Faded'
import { Row } from './Row'

type Props = StylableElementProps & {
	amount: number
	currency: string
	merchantName: string
	originalAmount: number | null
	originalCurrency: string | null
	transactionDate: string

	isLeftPadded?: boolean
}

export const Transaction = ({
	amount,
	currency = 'DKK',
	merchantName,
	originalAmount,
	originalCurrency,
	transactionDate,
	isLeftPadded = true,
	style,
	className,
}: Props) => (
	<Row style={style} className={className}>
		{isLeftPadded && (
			<Cell textAlign='center'>
				<EmptyChevron />
			</Cell>
		)}
		<Cell shouldExpand>
			<div>{merchantName}</div>
			<Faded>
				<FormattedDate value={transactionDate} day='2-digit' month='2-digit' year='numeric' />
			</Faded>
		</Cell>
		<Cell>
			<Amount
				amount={amount}
				currency={currency}
				userProvidedAmount={null}
				caption={
					isNonNullable(originalAmount) &&
					originalCurrency &&
					originalCurrency !== currency && (
						<FormattedNumber value={originalAmount} currency={originalCurrency} format='integer-currency' />
					)
				}
			/>
		</Cell>
	</Row>
)
